module.exports = __webpack_public_path__ + "img/product-brakepad-slider.6bd4f0e8.jpg";